import React, { FC } from "react";
import PageLayout from "./PageLayout";
import { useBgColor } from "../../../../hooks/personalization/useColors";

type PageLayoutProps = {
  bgColor: string;
  hideLogin: boolean;
  isMobile: boolean;
};

export type ContainerProps = Omit<PageLayoutProps, "bgColor">;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Container: FC<any> = (props) => {
  const bgColor = useBgColor();

  return <PageLayout {...props} bgColor={bgColor} />;
};

export default Container;
